import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ContentResponse } from 'src/app/models/content-response.model'
import { YieldsAnnualResponse } from 'src/app/models/yield-response.model'

@Injectable({
  providedIn: 'root',
})
export class FundContentService {
  public static readonly contentEndpoint = '/content'
  public static readonly marketPriceDisclosuresEndpoint =
    '/market-price-disclosures'
  public static readonly yieldsEndpoint = '/yields'

  constructor(private readonly http: HttpClient) {}

  getFundContent(fundId: string): Observable<ContentResponse> {
    return this.http.get<ContentResponse>(
      `vmf/api/${fundId}`.concat(FundContentService.contentEndpoint),
    )
  }

  getMarketPriceDisclosures(): Observable<any> {
    return this.http.get<any>(
      `vmf/api`.concat(FundContentService.marketPriceDisclosuresEndpoint),
    )
  }

  getYields(fundId: string): Observable<YieldsAnnualResponse> {
    return this.http.get<YieldsAnnualResponse>(
      `vmf/api/${fundId}`.concat(FundContentService.yieldsEndpoint),
    )
  }
}
